export default __webpack_public_path__ + "images/92995a1653fff484d8094ce8a0838082-family.webp";